




















import Enumerable from "linq";
import { Mixins, Prop, Watch, Emit, Component } from "vue-property-decorator";
import { HisInformationSetting } from "../../../../../../../base/domain/his";
import { HisInformationDirectoryFactory } from "../../../utilities";
import { DirectoryTreeNodesFactory } from "../../../../../../../../components/system/utilities";
import { IHisInformationTreeData, IHisInformationTreeNode } from "../../../../../../domain/editableFormat";
import { ElTree } from "element-ui/types/tree";

@Component
export default class HisInformationItemTypeSelector extends Mixins() {
  selectedData: IHisInformationTreeData = null;

  @Prop({ default: () => [] as HisInformationSetting[] })
  hisInformations: HisInformationSetting[];

  $refs!: {
    tree: ElTree<string, IHisInformationTreeData>,
  };

  get nodesData(): IHisInformationTreeData[] {
    const factory = new HisInformationDirectoryFactory();
    const directories = factory.create(this.hisInformations);
    const nodeFactory = new DirectoryTreeNodesFactory<string, HisInformationSetting>();
    return nodeFactory.create(directories);
  }

  handleNodeClicked(node: IHisInformationTreeData, nodeProperty: IHisInformationTreeNode, nodeSelf: any): void {
    this.selectedData = node;
  }

  changeSelection(key: string) {
    this.$nextTick(() => {
      const selectionTreeData = Enumerable.from(this.nodesData).firstOrDefault(s => s.source.key === key);
      if (!selectionTreeData) { return; }
      this.$refs.tree.setCurrentNode(selectionTreeData);
      this.selectedData = selectionTreeData;
      this.treeNodeSelected(this.selectedData);
    });
  }

  @Watch("selectedData")
  onSelectedDataUpdated(newValue: IHisInformationTreeData, oldValue: IHisInformationTreeData) {
    this.treeNodeSelected(newValue);
  }

  @Emit("treeNodeSelected")
  treeNodeSelected(value: IHisInformationTreeData): void {}
}
